import React from 'react';
import {Layout} from 'antd';
import {withRouter} from 'react-router';
import {observer} from 'mobx-react';
import Sidebar from '@components/Sidebar/Sidebar';
import GlobalHeader from '@components/GlobalHeader/GlobalHeader';

const {Content} = Layout;

@withRouter
@observer
class BasicLayout extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const globalLayoutHeight = {
            minHeight: '100vh',
            // border: '1px solid red'
        };
        return (
            <Layout style={globalLayoutHeight}>
                <Sidebar/>
                <Content>
                    <GlobalHeader/>
                    <Content>
                        {this.props.children}
                    </Content>
                </Content>
            </Layout>
        );
    }
}

export default BasicLayout;



// WEBPACK FOOTER //
// ./src/layouts/BasicLayout.jsx